export default __webpack_public_path__ + "static/media/FIDA.0c709e85.jpg";